import { defineStore } from "pinia";
import qs from "qs";
import Api from "@/api";

import { useGlobalStore } from '@/stores/global';

// TO ACCESS ROUTER ON PINIA
// this.router. ...
// TO ACCESS ROUTER ON PINIA

export const useReportStore = defineStore('reports', {

    state: () => ({
        metrics: {},
        chart: {},
        products: {},
        paymentMethods: {},
        conversions: {},
        recommendation: null,
        total: {},
        paginate: {},
        products_rep_filters:{
            'page': null,
            'date_start': null,
            'date_end': null,
        },
        payment_rep_filters:{
            'page': null,
            'date_start': null,
            'date_end': null,
        },
        conversions_rep_filters:{
            'page': null,
            'date_start': null,
            'date_end': null,
        },
    }),

    actions: {

        async tryProducts(params = null) {
            try {
                const response = await Api.get('reports/products', {params, paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: "brackets" });
                }});
                this.products = response.data.data;
                this.total = response.data
                this.paginate = response.data.meta;
            } catch (error) {
                useGlobalStore().tryIncomingErrors(error);
                return false;
            }
        },

        getTotalProductsQty() {
            let qty = 0;
            if(this.products.length) {
                for(let i = 0; i < this.products.length; i++){
                    qty = qty + this.products[i].qty;
                }
            }
            return qty;
        },

        getTotalProductsAmount() {
            let amount = 0;
            if(this.products.length) {
                for(let i = 0; i < this.products.length; i++){
                    amount = amount + this.products[i].amount;
                }
            }
            return amount;
        },

        async tryPaymentMethods(params = null) {
            try {
                const response = await Api.get('reports/payment-methods', {params, paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: "brackets" });
                }});
                this.paymentMethods = response.data.data;
                this.total = response.data
                this.paginate = response.data.meta;
            } catch (error) {
                useGlobalStore().tryIncomingErrors(error);
                return false;
            }
        },

        async tryConversions(params = null) {
            try {
                const response = await Api.get('reports/conversions', {params, paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: "brackets" });
                }});
                this.conversions = response.data.data;
                this.total = response.data
                this.paginate = response.data.meta;
            } catch (error) {
                useGlobalStore().tryIncomingErrors(error);
                return false;
            }
        },
    }
});